import { Reducer } from 'redux';
import ActionTypes, { TCallToActionState } from './types';

export const initialState: TCallToActionState = {
  error: null,
  data: null,
  loading: false,
};

const reducer: Reducer<TCallToActionState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CALL_TO_ACTION_R:
      return { ...state, loading: true, error: null };
    case ActionTypes.SET_CALL_TO_ACTION:
    case ActionTypes.GET_CALL_TO_ACTION_S:
    case ActionTypes.CLICK_CALL_TO_ACTION_S:
      return { ...state, data: action.payload, loading: false, error: null };
    case ActionTypes.CLICK_CALL_TO_ACTION_E:
    case ActionTypes.GET_CALL_TO_ACTION_E:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export { reducer as CallToActionReducer };
